import { GET_DASHBOARD_DATA, GET_ADMIN_DASHBOARD_DATA, GET_REGIONAL_ADMIN_DASHBOARD_DATA, SAVE_REMINDER_CONFIG, GET_COUNTRY_MODULE_DATA, UNMOUNT_DASHBOARD_DATA, GET_DASHBOARD_DATA_OFFLINE } from './../constants/constants';

export const userDashboard = (countryId: any) => {
    return {
        type: GET_DASHBOARD_DATA,
        payload: countryId
    }
}

export const userDashboardOffline = () => {
    return {
        type: GET_DASHBOARD_DATA_OFFLINE
    }
}
export const userAdminDashboard = (data: any) => {
    return {
        type: GET_ADMIN_DASHBOARD_DATA,
        payload:data// surveyId: any, isDashboard: any
    }
}
export const userRegionalAdminDashboard = (data: any) => {
    return {
        type: GET_REGIONAL_ADMIN_DASHBOARD_DATA,
        payload: data
    }
}

export const unmountDashboardData = () => {
    return {
        type: UNMOUNT_DASHBOARD_DATA
    }
}

export const saveReminderConfig = (data: any) => {
    return {
        type: SAVE_REMINDER_CONFIG,
        payload: data
    }
}


export const countryModulTypeDashboard = (data: any) => {
    return {
        type: GET_COUNTRY_MODULE_DATA,
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/actions/action.userDashboard.tsx